module.exports = __webpack_public_path__ + "img/step-2.411b0092.png";